import { Chart } from 'chart.js';
import { ChartData } from './bb-chart.component';

export const BB_BAR_LABEL_ID = 'bbBarLabel';
export const BB_BAR_GOAL_LINE_ID = 'bbBarGoalLine';

export const BbBarLabel = {
	id: BB_BAR_LABEL_ID,
	afterDatasetsDraw: ((chart: Chart, _args: [], options: any) => {
		if (options && options.display) {
			const context = chart.ctx;
			const metadata = chart.getDatasetMeta(0);
			context.save();
			context.beginPath();
			if (chart.data && chart.data.datasets && chart.data.datasets.length) {
				const data: ChartData[] = chart.data.datasets[0].data as ChartData[];
				metadata.data.forEach((element: any, index: number) => {
					context.textAlign = 'center';
					context.font = 'Lato 14px';
					context.fillStyle = '#5C5C5C';
					context.fillText(data[index].y.toFixed(options.toFixed), element.x, element.y - 8);
				});
			}
			context.closePath();
			context.restore();
		}
	}),
	defaults: {
		toFixed: 2
	}
};

export const BbBarGoalLine = {
	id: BB_BAR_GOAL_LINE_ID,
	afterDatasetsDraw: ((chart: Chart, _args: [], options: any) => {
		if (options && options.display && options.goal > 0) {
			const chartArea = chart.chartArea;

			if (
				!chartArea || !chart.data || !chart.data.datasets || !chart.data.datasets.length
				|| !chart.data.datasets[0].data && !chart.data.datasets[0].data.length
			) {
				return;
			}

			const context = chart.ctx;

			const chartHeight = chartArea.bottom - chartArea.top;

			const height = chartHeight - (chartHeight / chart.scales.y.max * options.goal) + chartArea.top;

			context.beginPath();

			context.moveTo(chartArea.left, height);
			context.lineTo(chartArea.right, height);
			context.strokeStyle = '#5C5C5C';
			context.fillText('Goal: ' + options.goal, chartArea.left + 3, height - 8);

			context.lineWidth = 2;
			context.stroke();
			context.fill();
			context.closePath();
		}
	})
};
